import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper } from 'lucide-react';
import { resolveArticleImage } from '../utils/articleUtils';
import { formatDate } from '../../utils/formatDate';
import PageSEO from '../../components/PageSEO';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SiteJournal() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/journal`)
      .then(r => r.json())
      .then(d => setArticles(d.articles || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="site-journal">
      <PageSEO
        title="Journal Médical — Conseils santé Matadi & Boma"
        description="Articles santé, conseils de prévention et actualités médicales du Centre Médical la Trinité à Matadi et Boma. Information fiable rédigée par notre équipe médicale."
        path="/journal"
      />
      <div className="site-page-head">
        <div className="site-page-head-inner">
          <h1 className="site-reveal">Journal Médical CMT</h1>
          <p className="site-reveal-1">
            Information santé fiable, conseils de prévention et actualités du Centre Médical
            la Trinité, rédigés par notre équipe médicale.
          </p>
        </div>
      </div>

      <section className="site-section">
        {!loading && articles.length === 0 && (
          <div className="site-card" style={{ textAlign: 'center', padding: '3rem' }} data-testid="journal-empty">
            <Newspaper size={40} style={{ color: 'var(--site-primary)', marginBottom: '1rem' }} />
            <h3>Les premiers articles arrivent bientôt</h3>
            <p>Notre équipe médicale prépare ses premiers dossiers santé. Revenez très vite !</p>
          </div>
        )}
        <div className="site-grid" data-testid="site-journal-grid">
          {articles.map(a => {
            const cover = resolveArticleImage(a.image_url);
            return (
              <Link to={`/journal/${a.slug}`} className="site-card site-article-card" key={a.article_id} data-testid={`journal-article-${a.slug}`}>
                {cover && (
                  <div className="site-article-thumb">
                    <img src={cover} alt={a.title} onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }} />
                  </div>
                )}
                <span className="site-article-cat">{a.category}</span>
                <h3>{a.title}</h3>
                <p>{a.excerpt}</p>
                <span className="site-article-meta">
                  {a.author} · {formatDate(a.created_at)}
                </span>
                <span className="site-article-more">Lire l'article <ArrowRight size={14} /></span>
              </Link>
            );
          })}
        </div>
      </section>
    </main>
  );
}
